var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video_baseFormBox"},[(_vm.options&&_vm.options.typeof=='article')?_c('div',{staticClass:"article_html",domProps:{"innerHTML":_vm._s(_vm.options.value)}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }